import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Pencil = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 9.5C28 6.487 25.512 4 22.5 4C21.038 4 19.637 4.575 18.613 5.612L5.463 18.762C4.513 19.712 4 20.962 4 22.3V27C4 27.55 4.45 28 5 28H9.713C11.051 28 12.301 27.475 13.25 26.538L26.4 13.388C27.425 12.363 28 10.963 28 9.5ZM11.825 25.125C11.262 25.688 10.5 26 9.7 26H6V22.288C6 21.488 6.313 20.738 6.875 20.163L16.813 10.225L21.763 15.175L11.825 25.125ZM24.975 11.975L23.187 13.762L18.237 8.812L20.025 7.025C20.675 6.375 21.575 6 22.5 6C24.425 6 26 7.575 26 9.5C26 10.425 25.625 11.325 24.975 11.975Z" />
	</svg>
);

export default Pencil;
